import React from 'react'
import { Button } from 'react-bootstrap';
import ERC20 from "../contracts/ERC20.json"

// Deposit ERC20 Tokens
// Lockbox instance (this.state.lockbox) is passed into to props as props.lockbox
// Lockbox address (this.state.lockboxAddress) is passed into props as props.lockboxAddress
// Address of sender (this.state.address) is passed into props as props.address
function DepositERC20Tab(props) {

    const handleDepositERC20 = (event) => {
        event.preventDefault();
        if (event.target.amount.value <= 0) {
            alert("Can't deposit " + event.target.amount.value + " tokens!");
        }
        else {
            submitDepositERC20(event.target.category.value, event.target.amount.value, event.target.address.value);
        }
    }

    const submitDepositERC20 = async (category, amount, address) => {
        // instance of erc20 contract for user to interact with
        const ERC20_instance = new window.web3.eth.Contract(ERC20.abi, address);

        // dynamic conversion of amount based on erc20 token's decimal precision
        const ERC20_decimals = await ERC20_instance.methods.decimals().call();
        amount = (amount * (10 ** ERC20_decimals)).toString();

        // user must approve spend of erc20 tokens before they can be transferred
        await ERC20_instance.methods.approve(props.lockboxAddress, amount).send({ from: props.address });
        await props.lockbox.methods.depositERC20(category, address, amount).send({ from: props.address });
    }

    return (
        <form onSubmit={handleDepositERC20}>
            <label>Category</label>
            <br />
            <input type="text" name="category" className="form-control w-25 center-block"></input>
            <br />
            <label>Deposit Amount</label>
            <br />
            <input type="number" step="0.000001" min="0" name="amount" className="form-control w-25 center-block"></input>
            <br />
            <label>ERC20 Address</label>
            <br />
            <input type="text" name="address" className="form-control w-25 center-block"></input>
            <br />
            <br />
            <Button variant="dark" type="submit">Submit Deposit</Button>
        </form>
    )
}

export default DepositERC20Tab
